<template>
  <div>
    <module-title title="收款规则设置">
      <el-popover
        popper-class="tip-popper"
        :append-to-body="false"
        placement="bottom-start"
        width="440"
        trigger="manual"
        v-model="tipVisible"
      >
        <p class="f-16 c-3 text-left m-b10">案例说明：</p>
        <img
          slot="reference"
          class="tips pointer"
          src="@/assets/qd/icon-tip.png"
          @click="tipVisible = !tipVisible"
        />
        <p class="f-14 c-3 text-left font-normal">
          单笔订单最大少收款金额为5,000元，单笔订单最大少收款金额比例为5%。
        </p>
        <p class="f-12 c-6 m-t8 text-left font-normal">
          买家已成功下单，交易订单金额为80,000.00元，依据上述设置，针对该笔订单卖家对买家接受的最大少收款金额为4,000元，买家打款金额只要大于等于76,000元，交易订单会自动完成收款，少收款金额在实提补退环节进行结算。
        </p>
        <el-button class="m-t18 fr" type="text" @click="tipVisible = !tipVisible">知道了</el-button>
      </el-popover>
    </module-title>

    <el-form ref="form" :model="form" label-width="318px">
      <el-form-item label="收款规则" prop="status">
        <el-radio :disabled="curType === 'view'" v-model="form.status" label="1">启用</el-radio>
        <el-radio :disabled="curType === 'view'" v-model="form.status" label="2">禁用</el-radio>
      </el-form-item>
      <el-form-item label="单笔订单最大少收款金额" prop="maxMoney">
        <el-input
          class="w-280"
          :disabled="curType === 'view'"
          placeholder="请输入"
          :value="form.maxMoney"
          @input="v => handleInput(v, 'maxMoney')"
        >
          <span class="f-13 c-3 m-l12 m-r12" slot="suffix">元</span>
        </el-input>
      </el-form-item>
      <el-form-item label="单笔订单最大少收款比例" prop="maxScale">
        <el-input
          class="w-280"
          :disabled="curType === 'view'"
          placeholder="请输入"
          :value="form.maxScale"
          @input="v => handleInput(v, 'maxScale')"
        >
          <span class="f-13 c-3 m-l12 m-r12" slot="suffix">%</span>
        </el-input>
      </el-form-item>
      <div class="m-l318">
        <el-checkbox
          :disabled="curType === 'view'"
          v-model="form.agree"
          @change="handleChange"
        ></el-checkbox>
        <span class="f-13 c-3"
          >勾选表示您已同意
          <span class="c-red pointer" @click="visible = true">《交易订单收款风险提示书》 </span>
        </span>
      </div>
    </el-form>
    <el-button class="m-l318 m-t20" type="primary" @click="handleSave">{{
      curType === 'edit' ? '保存' : '设置'
    }}</el-button>
    <el-button v-if="curType === 'edit'" class="m-t20" @click="handleCancel">取消</el-button>
    <module-title
      v-if="logVOList && logVOList.length > 0"
      class="m-t60"
      title="操作日志"
    ></module-title>
    <time-line :data="logVOList"></time-line>
    <span v-if="loadmore" class="loadmore" @click="getLog(page.pageNo + 1)">
      <i class="el-icon-refresh-right"></i>
      点击加载更多
    </span>
    <risk-reminder-dialog :visible.sync="visible"></risk-reminder-dialog>
  </div>
</template>

<script>
import ModuleTitle from '@/components/module-title'
import TimeLine from './components/timeline'
import RiskReminderDialog from './components/risk-reminder-dialog'
import NP from 'number-precision'

const REG_MONEY = /^[0-9]+([.]{1}[0-9]{0,2}){0,1}$/
const REG_SCALE = /^[1-9]\d{0,1}([.]{1}[0-9]{0,4}){0,1}$/
const MAX_MONEY = 10000
const MAX_SCALE = 13
const modeType = {
  edit: 'edit',
  view: 'view',
  init: 'init'
}
export default {
  name: 'CollectionSettings',
  components: { ModuleTitle, TimeLine, RiskReminderDialog },
  data() {
    return {
      tipVisible: false,
      form: {
        status: '',
        maxMoney: '',
        maxScale: '',
        agree: false
      },
      data: {},
      logVOList: [],
      curType: modeType.init,
      visible: false,
      page: {
        pageNo: 1,
        pageSize: 5
      },
      loadmore: false
    }
  },
  created() {
    this.fetch()
    this.getLog(this.page.pageNo)
  },
  methods: {
    async fetch() {
      try {
        const { success, data } = await this.$get('paycore.seller.getReceiptConfig')
        if (success && data && data[0] && Object.keys(data[0]).length > 0) {
          this.data = data[0]
          this.curType = modeType.view
          this.form.status = `${data[0].status}`
          this.form.maxMoney = NP.divide(data[0].maxSingleOrderWriteOff, 100)
          this.form.maxScale = data[0].maxSingleOrderWriteOffRatio
          this.form.agree = true
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getLog(pageNo) {
      try {
        const { success, data } = await this.$get('paycore.seller.getReceiptConfigLog', {
          queryReceiptConfigLogParam: { pageNo, pageSize: this.page.pageSize }
        })
        if (success && data && data[0]) {
          this.page.pageNo = data[0].pageNo
          this.logVOList =
            pageNo === 1 ? data[0].logVOList : this.logVOList.concat(data[0].logVOList)
          //判断是否有下一页
          this.loadmore = this.logVOList.length < data[0].totalCount ? true : false
        }
      } catch (e) {
        console.log(e)
      }
    },
    handleInput(val, key) {
      let reg = key === 'maxMoney' ? REG_MONEY : REG_SCALE
      if (val) {
        const match = val.match(reg)
        if (match) {
          if (key === 'maxMoney') {
            this.form[key] = match[0] > MAX_MONEY ? MAX_MONEY : match[0]
          } else {
            this.form[key] = match[0] > MAX_SCALE ? MAX_SCALE : match[0]
          }
        }
      } else {
        this.form[key] = ''
      }
    },
    async handleSave() {
      if (this.curType === modeType.view) {
        return (this.curType = modeType.edit)
      }
      if (!this.form.status) {
        return this.$message.error('请选择收款规则')
      }
      if (!this.form.maxMoney) {
        return this.$message.error('请输入单笔订单最大少收款金额')
      }
      if (!this.form.maxScale) {
        return this.$message.error('请输入单笔订单最大少收款比例')
      }
      if (!this.form.agree) {
        return this.$message.error('请同意《交易订单收款风险提示》')
      }
      try {
        const { success, data } = await this.$get('paycore.seller.saveReceiptConfig', {
          saveReceiptConfigParam: {
            maxSingleOrderWriteOff: NP.times(this.form.maxMoney, 100),
            maxSingleOrderWriteOffRatio: this.form.maxScale,
            status: this.form.status
          }
        })
        if (success && data) {
          if (data[0].success) {
            this.$message.success('设置成功')
            this.fetch()
            this.getLog(1)
            this.curType = modeType.view
          } else {
            data[0].errorMsg && this.$message.error(data[0].errorMsg)
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    handleCancel() {
      this.curType = modeType.view
      this.form.status = `${this.data.status}`
      this.form.maxMoney = NP.divide(this.data.maxSingleOrderWriteOff, 100)
      this.form.maxScale = this.data.maxSingleOrderWriteOffRatio
      this.form.agree = true
    },
    handleChange(v) {
      if (v) {
        this.visible = v
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  width: 12px;
  height: 12px;
  margin: 2px 0 0 8px;
}
/deep/ .tip-popper {
  padding: 30px 30px 14px 30px;
}
/deep/ .el-form-item {
  margin-bottom: 14px;
  .el-form-item__label {
    font-weight: 400;
  }
}
/deep/ .el-checkbox {
  min-width: 20px;
  line-height: 0px;
}
.w-280 {
  width: 280px;
}
.m-l318 {
  margin-left: 318px;
}
.loadmore {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #333;
  margin-left: 130px;
  cursor: pointer;
  &:hover {
    color: #f0242e;
  }
}
.text-left {
  text-align: left;
}
</style>
